import React from 'react';
import { motion } from 'framer-motion';
import { FaGlobe, FaUsers } from 'react-icons/fa';
import './About.css';

const About = () => {
  // Animation Variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3, // Bache hue elements ek ke baad ek aayenge
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { 
      opacity: 1, 
      y: 0, 
      transition: { duration: 0.8, ease: "easeOut" } 
    },
  };

  return (
    <section className="about-ultra-premium">
      <div className="about-container">
        <motion.div 
          className="about-grid"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, amount: 0.2 }} // Har baar scroll par chalega
        >
          
          {/* LEFT: VISUALS */}
          <motion.div className="about-visuals" variants={itemVariants}>
            <div className="about-image-main">
              <img src="https://images.unsplash.com/photo-1544644181-1484b3fdfc62?q=80&w=1000" alt="Travel Experience" />
              
              {/* Floating Experience Card with Infinite Float Animation */}
              <motion.div 
                className="experience-floating-card"
                animate={{ y: [0, -15, 0] }} // Upar niche floating effect
                transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
              >
                <div className="exp-circle">
                  <span className="exp-num">14+</span>
                </div>
                <div className="exp-info">
                  <h5>YEARS</h5>
                  <p>EXPERIENCE</p>
                </div>
              </motion.div>
            </div>
          </motion.div>

          {/* RIGHT: CONTENT */}
          <div className="about-details">
            <motion.span className="about-tag" variants={itemVariants}>
              SINCE 2012
            </motion.span>
            
            <motion.h2 className="about-heading" variants={itemVariants}>
              Chandrama Holidays: Where <br/> <span>Your</span> Trusted Travel Partner
            </motion.h2>

            <motion.p className="about-para" variants={itemVariants}>
             Since 2012, Chandrama Holidays has been helping travelers explore India with comfort, care, and confidence. Whether it’s a family vacation, a group tour, or a customized trip, we focus on honest pricing, reliable service, and smooth travel experiences that you’ll remember for a lifetime.

            </motion.p>

            {/* <div className="about-stats-grid">
              <motion.div className="about-stat-box" variants={itemVariants} whileHover={{ scale: 1.05 }}>
                <div className="stat-icon"><FaGlobe /></div>
                <div className="stat-data"><h3>500+</h3><p>Tours Done</p></div>
              </motion.div>
              
              <motion.div className="about-stat-box" variants={itemVariants} whileHover={{ scale: 1.05 }}>
                <div className="stat-icon"><FaUsers /></div>
                <div className="stat-data"><h3>25k+</h3><p>Happy Souls</p></div>
              </motion.div>
            </div> */}

            <motion.div className="about-btns" variants={itemVariants}>
              {/* <motion.button 
                className="btn-primary-about"
                whileHover={{ scale: 1.05, backgroundColor: "#1E88C8" }}
                whileTap={{ scale: 0.95 }}
              >
                KNOW OUR STORY
              </motion.button> */}
            </motion.div>
          </div>

        </motion.div>
      </div>
    </section>
  );
};

export default About;